/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { getRandomIntBetween } from 'cio/utils/numbers';
import { PathDotSettings } from 'cio/components/objects/landing-page/flow-chart';
import { task, timeout } from 'ember-concurrency';
import Ember from 'ember';

interface ObjectsFlowChartDotArgs {
  dot: PathDotSettings;
}

function generateDotAnimationDuration() {
  return getRandomIntBetween(2400, 5600);
}

function generateDotAnimationDelay() {
  return getRandomIntBetween(0, 4000);
}

export default class ObjectsFlowChartDot extends Component<ObjectsFlowChartDotArgs> {
  @tracked duration = 0;

  constructor(owner: unknown, args: ObjectsFlowChartDotArgs) {
    super(owner, args);

    this.duration = generateDotAnimationDuration();
  }

  willDestroy() {
    super.willDestroy();

    if (this.animateElement == null) {
      return;
    }

    this.animateElement.removeEventListener('endEvent', this.onAnimationEnd);
  }

  animateElement: SVGAnimateMotionElement | null = null;

  @action
  didInsertAnimationElement(element: SVGAnimateMotionElement) {
    this.animateElement = element;

    this.registerEventListeners();
    this.scheduleAnimation.perform();
  }

  @action
  registerEventListeners() {
    if (this.animateElement == null || Ember.testing) {
      return;
    }

    this.animateElement.addEventListener('endEvent', this.onAnimationEnd);
  }

  @action
  onAnimationEnd() {
    this.scheduleAnimation.perform();
  }

  scheduleAnimation = task({ drop: true }, async () => {
    if (this.animateElement == null) {
      return;
    }

    let delay = generateDotAnimationDelay();

    // Generate new duration for each restart of the animation
    this.duration = generateDotAnimationDuration();

    if (!Ember.testing) {
      await timeout(delay);
    }
    this.animateElement.beginElement();
  });
}
